<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import ListaEmails from './ListaEmails.vue'
  import NovoEmail from './NovoEmail.vue'
  import {Tipos} from './Tipos'

  export default {
    nome: 'contatos',
    directives: {mask},
    data () {
      return {
        isLoading: false,
        filtro: '',
        busca: '',
        history: {},
        tipoSelecionado: null
      }
    },
    computed: {
      tipos () {
        return Tipos
      }
    },
    mounted () {
      this.filtro = this.$route.query.filter || 'todos'
      this.$on('history', function (data) {
        delete this.history.mensagens
        this.history = data
        console.log('History', data)
      })
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      filterEmails (filter) {
        this.filtro = filter
        this.initFilters()
      },
      buscarEmails () {
        this.initFilters()
      },
      selecionaTipo (id) {
        if (this.tipoSelecionado === id) {
          this.tipoSelecionado = ''
          this.initFilters()
          return
        }
        this.tipoSelecionado = id
        this.initFilters()
      },
      initFilters () {
        this.$router.push('/website/atendimentos?filter=' + this.filtro + '&busca=' + this.busca + '&tipo=' + (this.tipoSelecionado || 0))
      }
    },
    components: {ListaEmails, NovoEmail}
  }
</script>

<template>
  <div class="contato">
    <div class="app-content-body ">

      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col w-md bg-light dk b-r bg-auto">
          <div class="wrapper b-b bg">
            <router-link class="btn btn-sm btn-danger w-xs font-bold" :to="{name: 'novo-email'}">Escrever</router-link>
          </div>
          <div class="wrapper hidden-sm hidden-xs" id="email-menu">
            <ul class="nav nav-pills nav-stacked nav-sm">
              <li @click="filterEmails('todos')" :class="{ active: filtro === 'todos' || filtro === null || filtro === ''}"><a>Todos <span class="badge pull-right">{{history.totalAll|number}}</span></a></li>
              <li @click="filterEmails('respondidos')" :class="{ active: filtro === 'respondidos'}"><a>Respondidos <span class="badge bg-success pull-right">{{history.respondidos|number}}</span></a>
              </li>
              <li @click="filterEmails('naorespondidos')" :class="{ active: filtro === 'naorespondidos'}"><a>Não
                respondidos <span class="badge bg-warning pull-right">{{history.naoRespondidos|number}}</span></a></li>
              <li @click="filterEmails('lixeira')" :class="{ active: filtro === 'lixeira'}"><a>Lixeira <span class="badge bg-danger pull-right">{{history.excluidos|number}}</span></a></li>
            </ul>
            <ul class="nav nav-pills nav-stacked nav-sm m-t">
              <li @click="selecionaTipo(id)" :class="{active: tipoSelecionado === id}" v-for="tipo, id in tipos">
                <a>
                  <i class="fa fa-fw fa-circle text-muted"
                     :style="{color: tipo.color}"></i>
                  {{tipo.name}}
                </a>
              </li>
            </ul>
            <div class="wrapper">
              <form v-on:submit.prevent="buscarEmails" name="label">
                <div class="input-group">
                  <input v-model="busca" type="text" class="form-control input-sm" placeholder="Protocolo/Email/Nome" required=""
                         aria-required="true" aria-invalid="true" style="">
                  <span class="input-group-btn">
                    <button class="btn btn-sm btn-default" type="submit" aria-disabled="true">Pesquisar</button>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
        <router-view></router-view>
      </div>

    </div>
  </div>
</template>



// WEBPACK FOOTER //
// Contatos.vue?133df08b